import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    getOnTimeShipments,
    getLateShipments,
    getEarlyShipments,
    getDeliveryPerformance,
    getDeliveryPerformanceByTimeframe,
} from '../../helpers';
import {
    deliveryPerformanceAnalyticsApiResponseSuccess,
    deliveryPerformanceAnalyticsApiResponseError,
} from './actions';
import { DeliveryPerformanceAnalyticsActionTypes } from './constants';

export function* getOnTimeShipmentsSaga({ payload: { query } }) {
    try {
        const response = yield call(getOnTimeShipments, query);
        yield put(deliveryPerformanceAnalyticsApiResponseSuccess(DeliveryPerformanceAnalyticsActionTypes.GET_ON_TIME_SHIPMENTS, response.data));
    } catch (error) {
        yield put(deliveryPerformanceAnalyticsApiResponseError(DeliveryPerformanceAnalyticsActionTypes.GET_ON_TIME_SHIPMENTS, error));
    }
}

export function* getLateShipmentsSaga({ payload: { query } }) {
    try {
        const response = yield call(getLateShipments, query);
        yield put(deliveryPerformanceAnalyticsApiResponseSuccess(DeliveryPerformanceAnalyticsActionTypes.GET_LATE_SHIPMENTS, response.data));
    } catch (error) {
        yield put(deliveryPerformanceAnalyticsApiResponseError(DeliveryPerformanceAnalyticsActionTypes.GET_LATE_SHIPMENTS, error));
    }
}

export function* getEarlyShipmentsSaga({ payload: { query } }) {
    try {
        const response = yield call(getEarlyShipments, query);
        yield put(deliveryPerformanceAnalyticsApiResponseSuccess(DeliveryPerformanceAnalyticsActionTypes.GET_EARLY_SHIPMENTS, response.data));
    } catch (error) {
        yield put(deliveryPerformanceAnalyticsApiResponseError(DeliveryPerformanceAnalyticsActionTypes.GET_EARLY_SHIPMENTS, error));
    }
}

export function* getDeliveryPerformanceSaga({ payload: { query } }) {
    try {
        const response = yield call(getDeliveryPerformance, query);
        yield put(deliveryPerformanceAnalyticsApiResponseSuccess(DeliveryPerformanceAnalyticsActionTypes.GET_DELIVERY_PERFORMANCE, response.data));
    } catch (error) {
        yield put(deliveryPerformanceAnalyticsApiResponseError(DeliveryPerformanceAnalyticsActionTypes.GET_DELIVERY_PERFORMANCE, error));
    }
}

export function* getDeliveryPerformanceByTimeframeSaga({ payload: { query } }) {
    try {
        const response = yield call(getDeliveryPerformanceByTimeframe, query);
        yield put(deliveryPerformanceAnalyticsApiResponseSuccess(DeliveryPerformanceAnalyticsActionTypes.GET_DELIVERY_PERFORMANCE_BY_TIMEFRAME, response.data));
    } catch (error) {
        yield put(deliveryPerformanceAnalyticsApiResponseError(DeliveryPerformanceAnalyticsActionTypes.GET_DELIVERY_PERFORMANCE_BY_TIMEFRAME, error));
    }
}

export function* watchGetOnTimeShipmentsSaga() {
    yield takeLatest(DeliveryPerformanceAnalyticsActionTypes.GET_ON_TIME_SHIPMENTS, getOnTimeShipmentsSaga);
}

export function* watchGetLateShipmentsSaga() {
    yield takeLatest(DeliveryPerformanceAnalyticsActionTypes.GET_LATE_SHIPMENTS, getLateShipmentsSaga);
}

export function* watchGetEarlyShipmentsSaga() {
    yield takeLatest(DeliveryPerformanceAnalyticsActionTypes.GET_EARLY_SHIPMENTS, getEarlyShipmentsSaga);
}

export function* watchGetDeliveryPerformanceSaga() {
    yield takeLatest(DeliveryPerformanceAnalyticsActionTypes.GET_DELIVERY_PERFORMANCE, getDeliveryPerformanceSaga);
}

export function* watchGetDeliveryPerformanceByTimeframeSaga() {
    yield takeLatest(DeliveryPerformanceAnalyticsActionTypes.GET_DELIVERY_PERFORMANCE_BY_TIMEFRAME, getDeliveryPerformanceByTimeframeSaga);
}

function* deliveryPerformanceAnalyticsSaga() {
    yield all([
        fork(watchGetOnTimeShipmentsSaga),
        fork(watchGetLateShipmentsSaga),
        fork(watchGetEarlyShipmentsSaga),
        fork(watchGetDeliveryPerformanceSaga),
        fork(watchGetDeliveryPerformanceByTimeframeSaga),
    ]);
}

export default deliveryPerformanceAnalyticsSaga;
